/** An operator's answer to an agent's question, as an answer rather than the sentence
 * the agent reads: the question it answers, then what they chose and wrote. */
import type { AnsweredQuestionFlag } from "../api/hooks/useStatefulAgents";
import { agentDisplayLabel } from "../utils/runParticipants";
import styles from "./AnsweredQuestion.module.css";

export const AnsweredQuestion = ({
  answer,
}: {
  answer: AnsweredQuestionFlag;
}) => (
  <div className={styles.answer}>
    <p className={styles.label}>
      Answered{" "}
      <a href={`#${answer.question_id}`}>
        {agentDisplayLabel(answer.agent)}&rsquo;s question
      </a>
    </p>
    <blockquote className={styles.question}>{answer.question}</blockquote>
    {answer.chosen.map((c) => (
      <div key={c.label} className={styles.chosen}>
        <strong>{c.label}</strong>
        {/* The agent wrote the option's description, so it reads as the option, not as
            the operator's words. */}
        {c.description && (
          <span className={styles.description}>{c.description}</span>
        )}
      </div>
    ))}
    {answer.other && <p className={styles.other}>{answer.other}</p>}
  </div>
);
